import { useNavigate } from "react-router-dom";
import { articleLinks } from "@/mocks/categories";

export default function ArticleSection() {
  const navigate = useNavigate();

  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block bg-accent-100 text-accent-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            Wissen
          </span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            OOPBuy Spreadsheet Guides & Artikel
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Lerne alles über OOPBuy Spreadsheet mit unseren 10 ausführlichen deutschsprachigen Artikeln
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {articleLinks.map((article) => (
            <button
              key={article.slug}
              onClick={() => { navigate(`/artikel/${article.slug}`); window.scrollTo({ top: 0, behavior: "smooth" }); }}
              className="text-left group bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all mb-3">
                <i className="ri-article-line"></i>
              </div>
              <h3 className="font-heading text-foreground-900 text-sm md:text-base mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                {article.title}
              </h3>
              <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2">
                {article.description}
              </p>
              <span className="inline-block mt-3 text-primary-500 text-xs font-medium group-hover:underline">
                Weiterlesen →
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}